import getColour from '@lendi-ui/commons/colours';
import MoreVert from '@lendi-ui/icon/MoreVert';
import MenuDropdown from '@lendi-ui/menu-dropdown';
import React from 'react';
import { analytics, EventCategory } from '../../../analytics';
import { Content, ContentItem, StyledMenu } from './style';
export var Menu = function (_a) {
    var onShowHistory = _a.onShowHistory;
    return (React.createElement(StyledMenu, null,
        React.createElement(MenuDropdown.Trigger, { className: "menu-trigger", iconAfter: React.createElement(MoreVert, { color: getColour('primary', '500'), width: "24px", height: "24px" }), onClick: function () {
                analytics({
                    event_name: 'Menu Clicked',
                    menuName: 'Kebab Menu',
                    path: window.location.href,
                    category: EventCategory.CHAT,
                });
            } }),
        React.createElement(Content, null,
            React.createElement(ContentItem, { size: "lg", onClick: onShowHistory }, "History"))));
};
//# sourceMappingURL=index.js.map